import DeleteBrandContainer from "./DeleteBrandContainer";
export default DeleteBrandContainer;
